export interface GeminiResponse {
  candidates: Array<{
    content: {
      parts: Array<{
        text?: string;
        inlineData?: {
          data: string;
          mimeType: string;
        };
      }>;
    };
  }>;
}

export interface GenerateDesignRequest {
  image: File;
  preferences: {
    style: string;
    customText: string;
  };
  language: 'en' | 'zh';
}

export interface DesignResult {
  image: string;
  description: string;
}

export class DesignError extends Error {
  constructor(
    message: string,
    public code: 'NETWORK_ERROR' | 'API_ERROR' | 'FILE_ERROR' | 'GENERATION_ERROR'
  ) {
    super(message);
    this.name = 'DesignError';
  }
}